import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, Link, Typography } from "@mui/material";
import DownloadIcon from "../../assets/image/svg/download_button.svg";
import "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/widgets/dataUploadSection/dataUpload.css";
import { getMasterData } from "../../services/mdmService/mdmService";
import { fetchAndDownloadReport } from "../../services/reportService";
import { openPopup } from "../../stateManagement/actions/popupActions";
import VideoPlayer from "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/widgets/dataUploadSection/VideoPlayer";
import { Loader } from "../../components/loader/Loader";
import UploadPopup from "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/widgets/dataUploadSection/uploadPopUp";
import { DomainValue } from "../../services/mdmService/types";
import { LogEntity } from "../../components/logsAndReports/reportAndLogsRowTypes";
import UpdatedUploadPopup from "./UpdatedUploadPopup";
import { useNavigate } from "react-router-dom";
import { setMdmCurrentEntity } from "../../stateManagement/actions/mdmDashboard";

export interface UpdatedDataUploadCardProps {
  selectedMaster: DomainValue | undefined;
  setSelectedMaster: React.Dispatch<
    React.SetStateAction<DomainValue | undefined>
  >;
  handleScreenSwitch: (screen: "logs" | "edit") => void;
  curData: LogEntity[];
  filteredData: LogEntity[];
  getLogs: () => Promise<void>;
}

export default function UpdatedDataUploadCard(props: UpdatedDataUploadCardProps) {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    props.getLogs();
  }, [loader]);

  if (!props.selectedMaster) {
    return <></>;
  }

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const downloadFile = async (id: string) => {
    console.log("id is this", id);
    const url = await getMasterData(id);
// // 
    if (url === "error") {
      openPopup("Error", "No Report Present");
      return;
    }
    fetchAndDownloadReport(url);
  };

  const formatDate = () => {
    const date = new Date();

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${hours}:${minutes}:${seconds}, ${day}-${month}-${year}`;
  };

  return (
    <div className="upload-card">
      <div className="header-decorator">
        <div
          style={{
            width: "40px",
            height: "40px",
            marginRight: "10px",
            marginLeft: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#FFFFFF 0% 0% no-repeat padding-box",
            border: "1px solid #00C6B1",
            opacity: 1,
            boxShadow: "0px 0px 8px #0000001A",
            borderRadius: "10px",
          }}
        >
          <img
            src={props.selectedMaster?.icon}
            alt="icon"
            style={{ width: "60%" }}
          />
        </div>
        <h6>{props.selectedMaster?.name}</h6>
      </div>
      <div className="instructions">
        <div className="instruction-title" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h5>Upload Master in Excel</h5>
          <div className="spacer" style={{ width: "5px" }}></div>
          <Box
            sx={{ width: "65%", backgroundColor: "#BCBCBC", height: "1px" }}
          ></Box>
        </div>
        <div className="video-iframe">
          <VideoPlayer />
        </div>
        <div className="download-button" onClick={(e) => {}}>
          <a
            href={
              props.selectedMaster.id !== "ProductImage"
                ? props.selectedMaster.dummyDataTemplateUrl
                : ""
            }
          >
            {/* <h6>
              {props.selectedMaster.id !== "ProductImage"
                ? "Download Sample Data" 
                : "    "}
            </h6> */}
          </a>
          <a
            href={
              props.selectedMaster.id !== "ProductImage"
                ? props.selectedMaster.templateUrl
                : ""
            }
          >
            <h6>
              {props.selectedMaster.id !== "ProductImage"
                ? "Download Template"
                : "    "}
            </h6>
          </a>
        </div>

        <div className="instruction-title" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h5>Master Information</h5>
          <div className="spacer" style={{ width: "5px" }}></div>
          <Box
            sx={{ width: "70%", backgroundColor: "#BCBCBC", height: "1px" }}
          ></Box>
        </div>

        <Box
          display="flex"
          justifyContent="space-between"
          flexDirection="column"
          height="28.5vh"
          paddingBottom="12px"
          boxSizing="border-box"
        >
          <Box className="group1">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Box>
                <Typography variant="body1" fontSize="14px">
                  Last Updated on :
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <Typography variant="body2" fontSize="14px" color="#606060">
                  {props.filteredData[
                    props.filteredData.findIndex(
                      (e) => e.response?.status === 200
                    )
                  ]?.lastModifiedTime ?? "No Records Available"}
                </Typography>
                <Link
                  onClick={(e) => {
                    if (props.selectedMaster?.id === "ProductImage") return;
                    if (
                      props.filteredData[
                        props.filteredData.findIndex(
                          (e) => e.response?.status === 200
                        )
                      ]?.response?.info?.statusReport
                    ) {
                      fetchAndDownloadReport(
                        props.filteredData[
                          props.filteredData.findIndex(
                            (e) => e.response?.status === 200
                          )
                        ]?.response?.info?.statusReport
                      );
                    } else {
                      openPopup("Error", "No Reports Found");
                    }
                  }}
                  underline="always"
                  variant="body2"
                  color="primary"
                  fontSize="11px"
                  fontWeight="w600"
                >
                  {props.selectedMaster.id !== "ProductImage"
                    ? "Status Report Download"
                    : ""}
                </Link>
              </Box>
            </Box>
            {/* Current Records */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography variant="body1" fontSize="14px">
                  Current Records :
                </Typography>
              </Box>

              <Box display="flex" alignItems="center">
                {/* <Typography variant="body2" color="#606060">
                  {`${props.filteredData.length} rows available`}
                </Typography> */}
                <Link
                onClick={(e) => {
                  downloadFile(props.selectedMaster?.entityName ?? "");
                }}
                //   onClick={(e) => {
                //     if (props.selectedMaster?.id === "ProductImage") return;
                //     if (
                //       props.filteredData[
                //         props.filteredData.findIndex(
                //           (e) => e.response?.status === 200
                //         )
                //       ]?.response?.info?.statusReport
                //     ) {
                //       fetchAndDownloadReport(
                //         props.filteredData[
                //           props.filteredData.findIndex(
                //             (e) => e.response?.status === 200
                //           )
                //         ]?.response?.info?.statusReport
                //       );
                //     } else {
                //       openPopup("Error", "No Reports Found");
                //     }
                //   }}
                  underline="always"
                  variant="body2"
                  color="primary"
                  fontSize="14px"
                  fontWeight="w600"
                >
                  {props.selectedMaster.id !== "ProductImage"
                    ? "Download"
                    : ""}
                </Link>
                <IconButton
                  onClick={(e) => {
                    downloadFile(props.selectedMaster?.entityName ?? "");
                  }}
                  sx={{
                    padding: "0px",
                    paddingTop: "4px",
                    paddingLeft: "6px",
                    paddingBottom: "8px",
                  }}
                >
                  <img
                    src={DownloadIcon}
                    alt="Download"
                    style={{ width: "16px", height: "14px" }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
          <Box display="flex" justifyContent="space-between" marginBottom={"20px"}>
            <Box>
              <Link
                onClick={(e) => {
                  props.handleScreenSwitch("logs");
                }}
                underline="always"
                variant="body2"
                color="primary"
              >
                See Logs
              </Link>
            </Box>

            <Box display={"flex"}>
              {props.filteredData[
                props.filteredData.findIndex((e) => e.response?.status === 200)
              ] &&
                (props.selectedMaster.entity === "User" ||
                  props.selectedMaster.entity === "OutletDetails" ||
                  (props.selectedMaster.entity === "ProductDetails" &&
                    props.selectedMaster.id !== "ProductImage")) && (
                  <>
                    <Button
                      variant="outlined"
                      onClick={(e) => {
                        props.handleScreenSwitch("edit");
                      }}
                      sx={{
                        color: "#02C6B1",
                        borderColor: "#02C6B1",
                        marginRight: "10px",
                      }}
                    >
                      Edit
                    </Button>
                  </>
                )}

                          <Button
                              variant="outlined"
                              sx={{ color: "#00C6B1",marginRight: "10px" }}
                              onClick={()=>{
                                setMdmCurrentEntity(props.selectedMaster);     
                                navigate("viewAndEdit")
                            }}
                          >
                             Edit
                          </Button>
              {loader ? (
                <Box height={"35px"} width={"35px"}>
                  <Loader />
                </Box>
              ) : (
                <>
                  <Button
                    variant="contained"
                    sx={{ color: "#ffffff", backgroundColor: "#00C6B1" }}
                    onClick={handleOpenPopup}
                  >
                    Upload Excel
                  </Button>
                  <UpdatedUploadPopup
                    open={isPopupOpen}
                    handleClose={handleClosePopup}
                    selectedMaster={props.selectedMaster}
                    loader={loader}
                    setLoader={setLoader}
                    setSelectedMaster={props.setSelectedMaster}
                  />
                </>
              )}
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  );
}
